/**
  メイントップページ
*/
<template>
  <v-ons-page >
    <ms-toolbar mode="top">
      <h1 class="page_header_title">{{category_name}}</h1>
    </ms-toolbar>
    
    <div class="content" ref="tab_content_main">
    <!--めくりページ-->
    <!--
    <div class="scroll_gif_wrapper" v-if="ScrollInfoVisible" @click="hideScrollInfo">
      <div class="scroll_gif">
        <p>スクロールできます</p>
        <img src="../assets/img/scroll.gif" width="250" alt="">
      </div>
    </div>
    -->
    <div class="tab_header" ref="TabHeader" @scroll="">
      <ul class="tab_inner" ref="TabInner" :style="{width:tab_width}">
        <li class="tab_item" :ref="get_tabindex(index)" :class="{active:index==tabbarIndex}" :style="{width:getTabWidth(page.page_name)+'px'}" v-for="(page, index) in WPPageSettings" :key="index"><a  @click="postTabChange(index,page.page_id)">{{page.page_name}}</a></li>
      </ul>
    </div>
    <slick ref="slick" :options="slickOptions" @beforeChange="handleBeforeChange">
        <div class="tab_content_" :class="{active:tabbar_index==index}" v-for="(page,index) in WPPageSettings"  :key="index">
          <div v-if="page.banner_position=='1'" class="banner_block">
              <a :href="page.banner_url" target="_blank"><img :src="page.banner_img" class="banner_img" width="100%"></a>
          </div>
          <div class="page_container">
            <div class="link_block " :key="page_no" v-for="(item, page_no) in page.items"
             @click="handleClickLink(item)"
             :style="{top: item.top, left: item.left, width: item.width, height: item.height}"
             :data-status="item.goods_status" :data-status2="item.goods_status2" :lock-time="item.lock_time"
             :class="checkLinkStatus(item)">
                <div class=notice_block>
                  <img src="../assets/img/notice.svg" class="ico_notice" alt="">
                  <p class="txt_notice" v-html="getStatusText(item)"></p>
                </div>
                <ons-ripple class="ripple"></ons-ripple>
            </div>
            <img class="bg_img" v-on:load="completeBgImg" :src="page.page_img" alt="">
          </div>
          <div v-if="page.banner_position=='2'" class="banner_block">
              <a :href="page.banner_url" target="_blank"><img :src="page.banner_img" class="banner_img" width="100%"></a>
          </div>
        </div>
    </slick>
   </div>
   <!--カートボタン-->
   <v-ons-fab position="bottom right" :visible="CartVisible" class="cart_fab" style="" @click="showCartPage">
      <span class="notification">{{CartItemCount}}</span>
      <v-ons-icon icon="fa-shopping-cart"></v-ons-icon>
   </v-ons-fab>
    
    <ms-tabbar></ms-tabbar>
  </v-ons-page>
</template>

<script>
import tabPage from "./SingleMenuPage";
import Tabbar from "../components/msTabbar";
import Toolbar from "../components/msToolbar";
import CartPage from "../pages/CartPage";
import SinglePage from "../pages/SinglePage";
import { mapGetters, mapActions } from "vuex";
import smoothscroll from 'smoothscroll-polyfill';

import '../../node_modules/slick-carousel/slick/slick.css'
import Slick from 'vue-slick';

export default {
  name: "menu_page",
  /*
  props:{
    propData: { type: Array, default: null }
  },
  */
  data() {
    return {
      ScrollInfoVisible:false,
      maxTabCount:0,
      tabbar_index: 0,
      bg_img_count: 0,
      loaded_img_count:0,
      dialogVisible:false,
      page_id:'1',
      page_settings: null,
      refresh: true,
      tab_width:'',
      category_name:'',
      category_id:'',
      page_group_id:'',
      wp_page_settings:[],
      slickOptions: {
          arrows:false,
          autoplay: false,
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight:true,
      },
    };
  },
  created: function() {
    var self=this

    this.setLoadingScreenVisibility(true)

    if(this.currentLangCode=='ja'){
      this.category_name=this.$attrs.propData.page_category_name==undefined?'':this.$attrs.propData.page_category_name
    }else if(this.currentLangCode=='en'){
      this.category_name=this.$attrs.propData.page_category_name_en==undefined?'':this.$attrs.propData.page_category_name_en
    }else if(this.currentLangCode=='ch'){
      this.category_name=this.$attrs.propData.page_category_name_ch==undefined?'':this.$attrs.propData.page_category_name_ch
    }
    
    
    this.category_id=this.$attrs.propData.page_category==undefined?'':this.$attrs.propData.page_category
    this.page_group_id=this.$attrs.propData.page_group_id==undefined?'':this.$attrs.propData.page_group_id
   
   if(this.page_group_id!=''){
     //時間制限品ページで関連商品がある場合は、自身のPageIDと一緒にカンマ区切りで渡す
     this.page_group_id=this.$attrs.propData.page_id+','+this.page_group_id
   }
   
   this.GetWPPageSettings({category_id:this.category_id, page_group_id:this.page_group_id})
    .then(result=>{
      //TabbarのWidthを計算
      
      self.wp_page_settings=result
      var t_width=0
      self.bg_img_count=result.length
      
      if(self.bg_img_count==0){
        self.setLoadingScreenVisibility(false)
      }
      result.forEach(function(item){
        t_width+= self.getTabWidth(item.page_name)
      })
       
      self.tab_width=t_width+'px'
      
      self.maxTabCount=result.length
      /*
      setTimeout(
        function(){
          self.setCurrentPage(self.$attrs.propData.page_id)
        },1000
      )
      */
     
    })


    
    
  },
  mounted:function(){
    
  },
  updated:function(){
    //カートの件数が20件に達した場合はアラートを出して確認ページへ遷移
    if(this.CartItemCount>=20){
      this.showErrorMessage('カートの件数が多くなりましたので、いったんオーダーを送信してください。')
      this.showCartPage()
    }
  },
  computed: {
    ...mapGetters([
      //'propsData',
      //'WPPageSettings',
      'CartVisible',
      'CartItemCount',
      'CartPageVisible',
      'CartItems',
      'GoodsStatus',
      'checkLinkStatus',
      'getStatusText',
      'localizeLabel',
      'ShowScrollInfo',
      'currentLangCode',
      ]),

    tabbarIndex: {
      // getter 関数
      get: function () {
        return this.tabbar_index
      },
      // setter 関数
      set: function (newValue) {
        this.tabbar_index = newValue
      }
    },
    
    WPPageSettings(){
      return this.wp_page_settings
    },
    currentPageName(){
      if(this.WPPageSettings.length>0){
        return this.WPPageSettings[this.tabbar_index].page_name
      }else{
        return ''
      }
      
    },
    
  },
  
  watch: {
    CartItems: {
      handler: function (val, oldVal) {
        console.log('cartItems changed')
      },
      deep: true
    },
    wp_page_settings(){
      this.ReInit()
    },
    
  },
  methods: {
    ...mapActions([
      "navigatePage",
      'navigateLink',
      "navigateOrderPage",
      'GetWPPageSettings',
      'GetGoodsStatus',
      'showLogMessage',
      'showErrorMessage',
      'SetWPPageSetting',
      'GetGoodsInfo',
      'SetCartPageVisible',
      'setLoadingScreenVisibility',
      'SetShowScrollInfo',
      'showMessage',
      'showLogMessage',
    ]),
    ReInit(event, slick) {
      this.$refs.slick.destroy()
      this.$nextTick(() => {
          this.$refs.slick.create()
      })
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
       this.handleTabChange(nextSlide)
        console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
    },
    completeBgImg(){
      this.setLoadingScreenVisibility(false)
      var self=this
      if(this.loaded_img_count==0){
        setTimeout(() => {
        this.setCurrentPage(this.$attrs.propData.page_id)
        this.handleTabChange(this.tabbar_index) 
        this.getGoodsStatus( this.WPPageSettings[this.tabbar_index], this.tabbar_index)
        
        if(self.ShowScrollInfo==0){
          self.ScrollInfoVisible=true
        }else{
          self.ScrollInfoVisible=false
        }
        }, 500);
        
      }
      this.loaded_img_count++
      
    },
    getOffsetLeft(str_name){
      var left=0
      var check=false
      var self=this
      this.WPPageSettings.forEach(function(item){
        if(item.page_name==str_name){
          check=true
        }
        if(check==false){
          left+=self.getTabWidth(item.page_name)
        }
      })
      return left
    },
    getTabWidth(str_name){
      if(this.currentLangCode=='en'){
        //英語の場合は半角
        return str_name.length*8+15
      }else{
        return str_name.length*14+15
      }
      
    },
    hideScrollInfo(){
      this.SetShowScrollInfo(1)
      this.ScrollInfoVisible=false
    },
    get_tabindex(index){
      return this.currentLangCode+'_cate_'+this.category_id+'_tab_'+index
    },
    
    handleClickLink(item){
      
      if(item.type=="outpage-link"){
        window.open(item.code, '_blank')
      }else{
        //同一ページ内かどうか
        if(this.isExistPage(item.code)==false){
          this.navigateLink({item:item})
        }else{
          this.setCurrentPage(item.code)
        }
      }
    },
    showCartPage(){
      //欠品情報を再取得
      var param=[]
      
      this.CartItems.forEach(item=>{
        if(item.code!='')
         param.push({ code:item.code})
      })
      this.setLoadingScreenVisibility(true)
      this.GetGoodsStatus(param)
      .then(()=>{
        //取得したステータスをページ設定アイテムに詰める
        //this.showLogMessage('欠品照会API取得')
        this.CartItems.forEach(item=>{
            var check=false
            this.GoodsStatus.forEach(goods=>{
              //欠品
              if(Number(item.code)==Number(goods.Goods) ){
                if(goods.GoodsStatus=='2'){
                  check=true
                }
              }
            })
            item['disabled']=check
        })
        this.SetCartPageVisible(true) 
        this.CartItems[0].count++
        this.CartItems[0].count--
        this.setLoadingScreenVisibility(false)
      })
      .catch((error)=>{
        debugger
        this.setLoadingScreenVisibility(false)
      })
    },
    over(idx){
      /*
      if(idx==0){
        this.tabbarIndex=this.maxTabCount-1
      }else if(idx==this.maxTabCount-1){
        this.tabbarIndex=0
      } 
      */
    },
    checkOrderPage(code, goods_status){
      //欠品商品以外だけ遷移する
      if(code==''){
        this.showErrorMessage('商品コードが設定されていません')
        return
      }
      if(goods_status==1){
        //商品情報を取得してからページ遷移
        this.setLoadingScreenVisibility(true)
        this.GetGoodsInfo(code)
        .then(result=>{
          this.navigateOrderPage({menu:'order', code:code, data:{mode:'back'}})
          this.setLoadingScreenVisibility(false)
        })
        .catch(()=>{
          this.setLoadingScreenVisibility(false)
        })
      }
    },
    changeTabCount(number){
      
      this.tabbar_index=Number(number)
      if(this.tabbar_index>=this.maxTabCount){
        this.tabbar_index=0
      }
      if(this.tabbar_index<0){
        this.tabbar_index=this.maxTabCount-1
      }
      
      this.getGoodsStatus( this.WPPageSettings[this.tabbar_index] )
    },
    showMenuList(){
      this.dialogVisible=true
    },
    postTabChange(activeIndex, page_id){
       this.setCurrentPage(page_id)
       //this.handleTabChange(activeIndex)
    },
    handleTabChange(index){
      //スクロール位置調整
      var $container=this.$refs['tab_content_main']
      $container.scrollTo({
          top: 0
      });
      this.tabbarIndex=index

      smoothscroll.polyfill();
      try{
        console.log('tabindex:'+this.tabbar_index)
        //var $curtab=document.getElementById(this.currentLangCode+'_cate_'+this.category_id+'_tab_'+this.tabbar_index)
        var $curtab=this.$refs[this.currentLangCode+'_cate_'+this.category_id+'_tab_'+this.tabbar_index][0]
        var $tab=this.$refs.TabHeader
        var clientWidth=this.getTabWidth($curtab.textContent)
        
        var left =this.getOffsetLeft($curtab.textContent)-$tab.clientWidth/2+clientWidth/2
      }catch(e){}
      
      //console.log($curtab.offsetLeft)
      $tab.scrollTo({
          left: left,
          behavior: "smooth"
      });

  //初期表示中のタブ変更時は初回説明領域を非表示にしない
     //this.hideScrollInfo()
     this.getGoodsStatus( this.WPPageSettings[this.tabbar_index], this.tabbar_index)
      
    },
    setCurrentPage(page_id){
      //初期表示ページを表示
      //ページIDから商品コードリストを取得し、欠品照会APIをコールして結果をセットする。
      var self=this
      var index=0
      var result=false
      this.WPPageSettings.forEach(page=>{
        if(page.page_id==page_id){
          //欠品APIをコール
          //this.getGoodsStatus(page ,index)
          this.tabbar_index=index //ページ切り替え
          result= true
        }
        index++;
      })
      this.dialogVisible=false
      this.$refs.slick.goTo(this.tabbar_index)
      return result
    },
    isExistPage(page_id){
      var result=false
      this.WPPageSettings.forEach(page=>{
        if(page.page_id==page_id){
          result= true
        }
      })
      return result
    },
    getGoodsStatus(page, tabindex){
      var param=[]
      page.items.forEach((item)=>{
        //item['goods_status']='1'
        //item['goods_status2']='0'
        if(item.code!='' && item.type=='item-link'){
          //複数商品の場合、欠品情報を取得しない
          //debugger
          if(item.code.indexOf(',')<0){
            param.push({ code:item.code, no:item.no})
            item['goods_status']='1'
            item['goods_status2']='0'
          }else{
            item['goods_status']='1'
            item['goods_status2']='0'
          }
        }
      })
      

      function success(goods_status){
        //goods_statusは存在しない商品コードでリクエストした場合、その商品のレスポンスは抜けた状態で帰ってくる
          //したがって、paramsの中身とgoods_statusの中身をチェックして、goods_statusに存在しないものはparamsから削除する
          var params=[]
          param.forEach(para=>{
            var check=false
            goods_status.forEach(goods=>{
              if(Number(para.code)==Number(goods.Goods)){
                check=true
              }
            })
            if(check==true){
              //goods_statusに存在する商品だけ詰め直す
              params.push(para)
            }  
          })
            
          //取得したステータスをページ設定アイテムに詰める
          //this.showLogMessage('欠品照会API取得')
          //同じ商品コードのリンク要素が複数あるので、LinkのNoとつきあわせる
          var param_idx=0
          
          goods_status.forEach(goods=>{
            page.items.forEach(item=>{
              //debugger
              if(Number(item.code)==Number(goods.Goods) && params[param_idx].no==item.no){
                //debugger
                if(goods.GoodsStatus){
                  item['goods_status']=goods.GoodsStatus
                }else{
                  item['goods_status']='1'
                }
                if(goods.GoodsStatus2){
                  item['goods_status2']=goods.GoodsStatus2
                }else{
                  item['goods_status2']='0'
                }
                item['lock_time']=goods.LockTime
              }
            })
            param_idx++
          })
          this.refresh = false;
          this.refresh = true; //強制的にカルーセルを再描画
          //this.setLoadingScreenVisibility(false)
      }


      //this.setLoadingScreenVisibility(true)
      if(param.length>0){
        this.GetGoodsStatus(param)
        .then(goods_status=>{
          success(goods_status)
          
        })
        .catch((error)=>{
          //りトライ
          
          if(error=='ネットワークに問題があります。<br>しばらくして再度実行してください。'){
            this.GetGoodsStatus(param)
              .then(goods_status=>{
                success(goods_status)
                
              })
              .catch((error)=>{
                this.$ons.notification.toast(error, { timeout: 1000, animation: 'default' })
              })
          }else{
          }

          //this.setLoadingScreenVisibility(false)
        })
      }
      
    }
  },
  components: {
    "ms-tabbar": Tabbar,
    "ms-toolbar": Toolbar,
    "ms-tabPage": tabPage,
    "ms-cartPage":CartPage,
    "ms-singlePage":SinglePage,
    Slick,
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";
.content{
  background-color: #111!important;
  color: $base-font-color;
  overflow: auto!important;
}

.page__content{
  top: 45px!important;

}
.page_container{

}
.page_prev{
  font-size: 30px;
  color: $base-font-color;
  position: fixed;
  top: 57px;
  left: 6px;
  z-index: 1000;
}
.page_next{
  font-size: 30px;
  color: $base-font-color;
  position: fixed;
  top: 57px;
  right: 6px;
  z-index: 1000;
}
.menu_page_header{
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  z-index: 100;
}
.caret{
  font-size: 20px;
  color: #E65407;
  position: absolute;
  right: 15px;
  margin: auto;
}
ons-button{
    color: $base-font-color;
    &.inp_number{
      min-width: 44px;
      font-size: 20px;
      text-align: center;
      border-color: $base-font-color;
      color: $base-font-color;
      display: flex;
      align-items: center;
      justify-content: center; 
    }
}
.menu_page_list_dialog .toolbar__title{
  color: $base-font-color;
}

h3{
  font-size: 16px;
  display: block;
  text-align: center;
  margin: 5px 0;
}


.scroll_gif_wrapper{
  position: fixed;
  width: 100%;
  color: #333;
  display: flex;
  justify-content: center;
  top: 95px;
  bottom: 0;
  padding-top: 10px;
  z-index: 200000;
  background-color: rgba(0,0,0,0.8);
}
.scroll_gif{
  position: relative;
  text-align: center;
  background-color: #fff;
  border-radius: 10px;
  font-size: 13px;
  font-weight: bold;
  height: 150px;
}
.scroll_gif:before{
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  top:-10px;
  left: 0;
  right: 0;
  margin: auto;
  border-bottom: 10px solid #fff;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
}
/*
.tab_content{
  display:none;
  &.active{
    display:block;
  }
}
*/

.slider,
.slick-slider,
.slick-list,
.slick-track,
.slick-slide{
  touch-action:auto!important;
}

/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/MenuPage.vue